import { render, staticRenderFns } from "./mainCategoryProduct.vue?vue&type=template&id=c1fc61ba&scoped=true"
import script from "./mainCategoryProduct.vue?vue&type=script&lang=js"
export * from "./mainCategoryProduct.vue?vue&type=script&lang=js"
import style0 from "./mainCategoryProduct.vue?vue&type=style&index=0&id=c1fc61ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1fc61ba",
  null
  
)

export default component.exports